var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"do-root"},[_c('client-block',{attrs:{"title":"Propriétaire","icon":"fas fa-user","id-prefix":"proprietaire","value":_vm.proprietaire},on:{"input":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }